module.exports = __webpack_public_path__ + "static/media/Make My Love Your Home - Instrumental Version.45303a79.jpg";